import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import FAQSection from './components/FAQSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <FAQSection />
        <RankingSection />
        <CarouselSection />
        <TopicsSection />
        <AboutSection />
        <UpdatesSection />
        <CardsSection />
        <AppSection />
        <ContactSection />
        <CommentsSection />
        <MediaSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}